var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropoff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8748 14.5833V13.125C16.8748 12.3195 16.2219 11.6666 15.4165 11.6666C14.6111 11.6666 13.9582 12.3195 13.9582 13.125V14.5833M18.3332 8.33329H1.6665M18.3332 9.16663V6.83329C18.3332 5.89987 18.3332 5.43316 18.1515 5.07664C17.9917 4.76304 17.7368 4.50807 17.4232 4.34828C17.0666 4.16663 16.5999 4.16663 15.6665 4.16663H4.33317C3.39975 4.16663 2.93304 4.16663 2.57652 4.34828C2.26292 4.50807 2.00795 4.76304 1.84816 5.07664C1.6665 5.43316 1.6665 5.89987 1.6665 6.83329V13.1666C1.6665 14.1 1.6665 14.5668 1.84816 14.9233C2.00795 15.2369 2.26292 15.4918 2.57652 15.6516C2.93304 15.8333 3.39975 15.8333 4.33317 15.8333H9.1665M13.8332 17.9166H16.9998C17.4665 17.9166 17.6999 17.9166 17.8782 17.8258C18.035 17.7459 18.1624 17.6184 18.2423 17.4616C18.3332 17.2834 18.3332 17.05 18.3332 16.5833V15.9166C18.3332 15.4499 18.3332 15.2166 18.2423 15.0383C18.1624 14.8815 18.035 14.754 17.8782 14.6741C17.6999 14.5833 17.4665 14.5833 16.9998 14.5833H13.8332C13.3665 14.5833 13.1331 14.5833 12.9548 14.6741C12.798 14.754 12.6706 14.8815 12.5907 15.0383C12.4998 15.2166 12.4998 15.4499 12.4998 15.9166V16.5833C12.4998 17.05 12.4998 17.2834 12.5907 17.4616C12.6706 17.6184 12.798 17.7459 12.9548 17.8258C13.1331 17.9166 13.3665 17.9166 13.8332 17.9166Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropoff);
export default __webpack_public_path__ + "static/media/dropoff.2861f31f9fb432e602d1ad0518428ba0.svg";
export { ForwardRef as ReactComponent };